import { Plus, X, ArrowRight } from 'lucide-react'
import ColumnInput from './ColumnInput'
import './editors.css'

const CAST_TYPES = [
  { value: '', label: '(no cast)' },
  { value: 'string', label: 'string' },
  { value: 'integer', label: 'integer' },
  { value: 'long', label: 'long' },
  { value: 'float', label: 'float' },
  { value: 'double', label: 'double' },
  { value: 'decimal', label: 'decimal' },
  { value: 'boolean', label: 'boolean' },
  { value: 'date', label: 'date' },
  { value: 'timestamp', label: 'timestamp' },
  { value: 'binary', label: 'binary' },
]

const EMPTY_MAPPING = { source: '', target: '', type: '', drop: false }

function parseValue(raw) {
  if (!raw) return []
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function ColumnMappingEditor({ value, onChange, disabled, columns }) {
  const mappings = parseValue(value)

  const emit = (next) => onChange(JSON.stringify(next))

  const updateMapping = (idx, key, val) => {
    const updated = [...mappings]
    updated[idx] = { ...updated[idx], [key]: val }
    emit(updated)
  }

  const addMapping = () => {
    emit([...mappings, { ...EMPTY_MAPPING }])
  }

  const removeMapping = (idx) => {
    emit(mappings.filter((_, i) => i !== idx))
  }

  return (
    <div>
      {mappings.map((m, idx) => (
        <div key={idx} className="editor-row">
          <ColumnInput
            columns={columns}
            value={m.source}
            onChange={(val) => updateMapping(idx, 'source', val)}
            placeholder="Source column"
            disabled={disabled}
          />
          <span className="editor-arrow">
            <ArrowRight size={12} />
          </span>
          <input
            className="editor-input"
            value={m.target || ''}
            onChange={(e) => updateMapping(idx, 'target', e.target.value)}
            placeholder="Target column"
            disabled={disabled || m.drop}
            style={m.drop ? { opacity: 0.4 } : undefined}
          />
          <select
            className="editor-select"
            value={m.type || ''}
            onChange={(e) => updateMapping(idx, 'type', e.target.value)}
            disabled={disabled}
            style={{ minWidth: '70px' }}
          >
            {CAST_TYPES.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
          <label title="Drop this column" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flexShrink: 0 }}>
            <input
              type="checkbox"
              className="editor-checkbox"
              checked={m.drop || false}
              onChange={(e) => updateMapping(idx, 'drop', e.target.checked)}
              disabled={disabled}
            />
          </label>
          <button
            className="editor-remove-btn"
            onClick={() => removeMapping(idx)}
            disabled={disabled}
            title="Remove mapping"
          >
            <X size={12} />
          </button>
        </div>
      ))}

      {mappings.length === 0 && (
        <div className="editor-empty">No column mappings defined</div>
      )}

      <button
        className="editor-add-btn"
        onClick={addMapping}
        disabled={disabled}
      >
        <Plus size={12} />
        Add Mapping
      </button>
    </div>
  )
}

export default ColumnMappingEditor
